import { Navigate } from "react-router-dom";
import { getSavedToken, isTokenExpired } from "../utils/tokenHelper";
export default function ProfileSetupRoute({ children }) {
  const tokenData = getSavedToken();

  const isLoggedIn =
    localStorage.getItem("isLoggedIn") === "true" &&
    tokenData &&
    tokenData.access_token &&
    !isTokenExpired(tokenData);

  if (!isLoggedIn) return <Navigate to="/login" replace />;

  const isNewUser = localStorage.getItem("isNewUser") === "true";

  if (!isNewUser) return <Navigate to="/home" replace />;

  return children;
}